import {BeneficiaireRapatriementResponse} from '../../data/types/interface/Assurance/AssuranceRapatriement/devis';

interface TrancheAgeCount {
  trancheAge: string;
  count: number;
}

export const countBeneficiairesRapatriementByTrancheAge = (
  beneficiaires: BeneficiaireRapatriementResponse[],
): TrancheAgeCount[] => {
  const trancheAgeMap: {[key: string]: number} = {};

  beneficiaires.forEach(beneficiaire => {
    const trancheAge = beneficiaire.tarification.trancheAge;
    if (trancheAgeMap[trancheAge]) {
      trancheAgeMap[trancheAge]++;
    } else {
      trancheAgeMap[trancheAge] = 1;
    }
  });

  return Object.keys(trancheAgeMap).map(trancheAge => ({
    trancheAge,
    count: trancheAgeMap[trancheAge],
  }));
};
